var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "d-inline-block",
          attrs: { model: _vm.form, rules: _vm.rules, inline: true },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "from" } },
            [
              _c("el-date-picker", {
                attrs: {
                  placeholder: "Start",
                  clearable: "",
                  type: "datetime",
                  format: _vm.dateFormat,
                  "value-format": _vm.formDateFormat,
                },
                model: {
                  value: _vm.form.from,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "from", $$v)
                  },
                  expression: "form.from",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "till" } },
            [
              _c("el-date-picker", {
                attrs: {
                  placeholder: "End",
                  clearable: "",
                  type: "datetime",
                  format: _vm.dateFormat,
                  "value-format": _vm.formDateFormat,
                },
                model: {
                  value: _vm.form.till,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "till", $$v)
                  },
                  expression: "form.till",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "d-inline-block align-top",
              attrs: { type: "primary" },
              on: { click: _vm.build },
            },
            [_vm._v("Build")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }